import { styled } from "@mui/material";
import { Colors } from "../util/Colors";

export const Card = styled("div")({
    backgroundColor: Colors.WHITE,
    borderRadius: 16,
    border: `1px solid ${Colors.GREY_200}`,
    minWidth: "min-content",
});
